/**
 * Login_Service.ts
 * POST /v1/auth/login
 *
 * Stores org + user data via Token_Handler on success.
 */

import axiosInstance from '../../api-endpoints/axiosInstance';
import { Token_Handler } from '../../storage/tokenHandler';
import { Platform_Login_Url } from '../../api-endpoints/api-endpoints';
import { LoginResponse } from '../../schema/auth/login';

export const loginOrg = async (email: string, password: string): Promise<LoginResponse> => {
  const { data } = await axiosInstance.post<LoginResponse>(Platform_Login_Url, { email, password });

  // Response shape: { data: { user: { id, first_name, last_name }, org: { id, name } } }
  const user = data?.data?.user;
  const org  = data?.data?.org;

  // Start clean: wipe every product namespace before writing this session's
  // data, so display metadata from a previous account/product can't linger in
  // localStorage (the login screen was showing stale sk_<product>_* values).
  await Token_Handler.clearAll();

  await Promise.all([
    org?.id          && Token_Handler.setOrgId(org.id),
    org?.name        && Token_Handler.setBusinessName(org.name),
    user?.first_name && Token_Handler.setFirstName(user.first_name),
    user?.last_name  && Token_Handler.setLastName(user.last_name),
  ].filter(Boolean));

  return data;
};
